import { render } from "./LoadMorePagination.vue?vue&type=template&id=8576d63a&ts=true&lang=pug"
import script from "./LoadMorePagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadMorePagination.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__